import { apiSlice } from './apiSlice';

export const billingApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createBillingCheckoutSession: builder.mutation({
      query: (planType) => ({
        url: '/api/billing/checkout-session',
        method: 'POST',
        body: { planType },
      }),
    }),
    createBillingPortalSession: builder.mutation({
      query: () => ({
        url: '/api/billing/portal-session',
        method: 'POST',
      }),
    }),
  }),
});

export const {
  useCreateBillingCheckoutSessionMutation,
  useCreateBillingPortalSessionMutation,
} = billingApiSlice;